import React, { useEffect, useState, useContext } from 'react';
import { Time, DateFormatter } from "@internationalized/date";
import { getClientTimeFromStr } from '@/shared/functions';
import { Slide } from '@/shared/types';
import { X, Check, Clock, HourglassHigh } from "@phosphor-icons/react";
import { FeaturesContext } from '../../app/contexts';
const formatter = new DateFormatter('en-US', {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: true
});
const tzDisplay = (tz: string) => {
  if (!tz) {
    return '';
  }
  const tzStr = tz.split('/').join(' / ').replace(/_/g, ' ');
  return tzStr;
};
const Times = (props: {
  value: string;
  data: Slide;
}): JSX.Element => {
  const [time, setTime] = useState<Time | null>(typeof props.value === 'string' ? getClientTimeFromStr(props.value) : null);
  const [timezone, setTimezone] = useState<string | null>(null);
  useEffect(() => {
    if (typeof props.value === 'string') {
      setTime(getClientTimeFromStr(props.value));
      if (props.data?.eventLocalTimezone) {
        setTimezone(props.data.eventLocalTimezone);
      }
    } else {
      setTime(null);
    }
  }, [props.data, props.value]);
  return <div className="flex flex-row items-center justify-center" data-sentry-component="Times" data-sentry-source-file="times.tsx">
      {!time && <div className={`flex justify-right items-center`}>Not Specified</div>}
      {time && <div className={`flex flex-col justify-right items-center`}>
          <div className="flex flex-row items-center justify-center gap-1">
            {props.data?.isTimeValid ? <Clock className="text-green-200 -mb-[14px]" size={14} weight="duotone" /> : <HourglassHigh className="text-yellow-500 -mb-[10px] opacity-0" size={1} weight="bold" />}
            <div className="p-0 m-0 h-[14px]">
              {time ? formatter.format(new Date(2025, 1, 1, time.hour, time.minute, time.second)) : props.value}
            </div>
          </div>
          {timezone && <div className="w-[85px] mt-[12px] break-words text-wrap leading-[16px]">
              {tzDisplay(timezone)}
            </div>}
        </div>}
    </div>;
};
Times.displayName = 'Times';
export default Times;